// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"d352b9c8","656":"19647085","756":"c49b8b66","831":"6b6554a8","968":"4bd94991"}[chunkId] + ".chunk.js";
};